import { useContext, useEffect, useState } from "react";
import { Auth } from "../../contexts/ridersUserContext";
import classNames from "classnames";
import { MiniBrowser, Screen, Terminal } from "./";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";

import { LanguageContext } from "../../contexts/languageContext";

export const Simulation = ({
  style,
  workspaceId,
  checkPoint,
  isResizing,
}: any) => {
  const { isTerminalOpen, godotContainerRef, collapsedSidebar, yamlData } =
    useContext<any>(Screen.context);

  const { language } = useContext<any>(LanguageContext);

  const [simulationUrl, setSimulationUrl] = useState<string | null>(null);

  const { project, overrideDesignMode } = useContext<any>(Auth.context);
  const { activeChapter, chapterKey } = useContext<any>(Screen.context);

  const [fullscreen, setFullscreen] = useState<null | string>(null);

  const [module, setModule] = useState<string>("");
  const [simulationParams, setSimulationParams] = useState<any>([]);

  const updateModuleInUrl = (
    originalUrl: string,
    newModuleName: string,
    chapterParams?: any
  ) => {
    const url = new URL(originalUrl);
    const params = url.searchParams;

    if (newModuleName) {
      if (params.has("module")) {
        params.set("module", newModuleName);
      } else {
        params.append("module", newModuleName);
      }
    }

    if (chapterParams) {
      Object.keys(chapterParams).forEach((key) => {
        if (params.has(key)) {
          params.set(key, chapterParams[key]);
        } else {
          params.append(key, chapterParams[key]);
        }
      });
    }

    if (params.has("language")) {
      params.set("language", language.toLowerCase());
    } else {
      params.append("language", language.toLowerCase());
    }

    // Modify module parameter for design mode, only when dualscenerobot mode is active
    if (params.has("editor_design_mode") && (params.get("editor_design_mode") === "dualscenerobot")){
      const module_param = params.get("module"); // Fetch current module value 

      if ((overrideDesignMode === "teacher") && module_param?.startsWith("-")){
        // Enable editing modes for teachers if disabled. 
        // Remove the first '-' character from module value.  
        params.set("module", module_param.replace("-", ""));
      }
      else if ((overrideDesignMode === "student") && !module_param?.startsWith("-")){
        // Disable editing modes for students if enabled.
        // Add '-' character at the start. 
        params.set("module", "-"+module_param);
      }
    }

    return url.toString();
  };

  // useEffect(() => {
  //   if (activeChapter) {
  //     const simulation = activeChapter.cells.find(
  //       (x: any) => x.type === "Simulation"
  //     );

  //     if (project.simulationUrl) {
  //       const url = new URL(updateModuleInUrl(project.simulationUrl, module));
  //       const params = url.searchParams;

  //       setSimulationParams(
  //         Array.from(params.keys()).map((key) => {
  //           return { [key]: params.get(key) };
  //         })
  //       );

  //       return;
  //     }

  //     if (simulation?.module) {
  //       if (simulation.url) {
  //         setSimulationUrl(simulation.url);
  //       }
  //       console.log("simulation?.module: ", simulation?.module);
  //       setModule(simulation?.module);
  //     } else {
  //       setModule("");
  //     }
  //     if (simulation?.params) {
  //       setSimulationParams(simulation.params);
  //     }
  //   }
  // }, [chapterKey]);

  useEffect(() => {
    if (activeChapter) {
      const simulation = activeChapter.cells.find(
        (x: any) => x.type === "Simulation"
      );
      if (simulation?.module) {
        if (simulation.url) {
          setSimulationUrl(simulation.url);
        }
        console.log("simulation?.module: ", simulation?.module);
        setModule(simulation?.module);
      } else {
        setModule("");
      }
    }
  }, [chapterKey]);

  useEffect(() => {
    const paramsString = simulationParams
      .map(
        (param: any) => `${Object.keys(param)[0]}:${Object.values(param)[0]}`
      )
      .join(" ");

    console.log("paramsString: ", paramsString);

    godotContainerRef.current?.contentWindow.postMessage(
      JSON.stringify({
        action: "setStemboxParams",
        parameters: paramsString,
      }),
      "*"
    );
  }, [simulationParams]);

  return (
    <div
      style={style}
      id={`tablist-${workspaceId}`}
      className="fit overflow-hidden simulation-tab"
    >
      <div
        className={classNames(
          checkPoint ? "grid-rows-[0.6fr_1fr]" : "grid-rows-[1fr_0.6fr]",
          "fit"
        )}
      >
        <div
          className={classNames(
            checkPoint ? "order-2" : "",
            "flex-col justify-center items-center bg-black text-white rounded-b-[30px] rounded-t-[15px] overflow-hidden transition-all",
            {
              "relative fit": fullscreen !== "simulator",
              "fixed top-5 right-4 bottom-5 z-[99]": fullscreen === "simulator",
              "left-[100px]": collapsedSidebar && fullscreen === "simulator",
              "left-[330px]": !collapsedSidebar && fullscreen === "simulator",
            }
          )}
        >
          <div
            className="bg-black w-10 h-6 hover:h-12 hover:w-16 px-3 absolute right-0 top-0 rounded-bl-full transition-all z-[299] duration-500 pointer flex items-center justify-center cursor-pointer hover:text-2xl"
            onClick={() => {
              setFullscreen(fullscreen === "simulator" ? null : "simulator");
            }}
          >
            <span className="">
              {fullscreen === "simulator" ? (
                <MdFullscreenExit />
              ) : (
                <MdFullscreen />
              )}
            </span>
          </div>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: isResizing ? 1000 : -1,
            }}
          />
          <MiniBrowser
            key={project.simulationUrl ? chapterKey : simulationUrl}
            src={
              project.simulationUrl
                ? `${updateModuleInUrl(
                    simulationUrl || project.simulationUrl,
                    module,
                    simulationParams?.reduce((acc: any, param: any) => {
                      return { ...acc, ...param };
                    }, {})
                  )}`
                : `https://d32lhafmwoak77.cloudfront.net/projects/stembox/${
                    yamlData.branch
                  }/index.html?containerless&language=${language.toLowerCase()}`
            }
            refrence={godotContainerRef}
            className="overflow-hidden"
          />

          <Terminal
            className={`opacity-70 absolute w-full transition-all left-0 h-72`}
            style={{
              height: 288,
              bottom: isTerminalOpen ? 0 : -288,
            }}
          />
        </div>
      </div>
    </div>
  );
};
